import { Component, Input, OnInit, Output, EventEmitter, inject, DestroyRef } from '@angular/core';
import { Capability } from 'src/app/models/service/capability';
import { MatDialog } from '@angular/material/dialog';
import { CapabilityDetailsComponent } from 'src/app/components/capability-details/capability-details.component';
import { CapabilitiesService } from 'src/app/services/api/capabilities.service';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-view-capability-card',
    templateUrl: './view-capability-card.component.html',
    styleUrls: ['./view-capability-card.component.scss'],
    standalone: false
})
export class ViewCapabilityCardComponent implements OnInit  {

  @Input() capability: Capability;
  @Input() selectable = false;
  @Input() isUpdated = true;
  @Output() selectionChanged = new EventEmitter();
  filterSubscription: Subscription;
  descriptionData: any;
  description: any;
  private destroyRef = inject(DestroyRef);


  constructor(private matDialog: MatDialog, private capabilitiesService: CapabilitiesService) {
  }

  ngOnInit(): void {
    if(!this.capability?.description) {
      this.viewDescription();
    } else {
      this.description = this.capability?.description;
    }
  }

  async viewDescription(): Promise<void> {
  this.filterSubscription =
      (await (this.capabilitiesService.getCapabilitiesView({ name: this.capability.name, version: this.capability.version })))
        // eslint-disable-next-line rxjs-angular/prefer-takeuntil
        .subscribe((response: any) => {
          this.description = response.description;
        });
  }

  toggleSelection(): void {
    this.capability.selected = !this.capability.selected;
    this.selectionChanged.emit(this.capability);
  }

  async viewDetails(): Promise<void> {
    this.filterSubscription =
      (await this.capabilitiesService.getCapabilitiesView({ name: this.capability.name, version: this.capability.version }))
        // eslint-disable-next-line rxjs-angular/prefer-takeuntil
        .subscribe(response => {
          this.viewDetailsDescription(response);
        });

  }

  viewDetailsDescription(response): void {
    if(response) {
      this.matDialog.open(CapabilityDetailsComponent, {
        minHeight: '533px',
        width: '748px',
        panelClass: 'flex-dialog',
        data: {
          capability: this.capability,
          selectable: this.selectable,
          description: response.description,
          version: response.version,
          releaseVersion: response.releaseVersion,
          isAMR: response.isAMR
        }
      })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.toggleSelection();
        }
      });
    }
  }
}
